var map = {
	"./culik/main-top-min.png": "ddf5",
	"./menanga/main-top-min.png": "3e85",
	"./remun-surat/main-top-min.png": "3d0d",
	"./sangsit/main-top-min.png": "8d08",
	"./sibetan/main-top-min.png": "18b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcdc";